import React from "react";

export class UI {

  public static modalMaskStyle(): React.CSSProperties {
    return {background: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)"};
  }
}
